// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== collfunctions.js =====
// ===== funciones.js =====
// =========================================================
// MUNDIAL 2026 - Funciones de eventos de colecciones
// Toda la logica de los nodos <script> de los .xne vive aqui.
// Cada funcion recibe `self` como parametro (contexto de la coll).
// ui, appData son globales del runtime XOne y NO se pasan.
// Motor: Rhino (ES5) - operadores literales, sin entidades XML.
// =========================================================


// ---------------------------------------------------------
// EntradaApp.xne - Pantalla splash
// ---------------------------------------------------------
function EntradaApp_beforeEdit(self) {
    self.MAP_TROFEO = EMOJI_TROFEO;
    self.MAP_BALON = EMOJI_BALON;
    self.MAP_TITULO = "MUNDIAL";
    self.MAP_ANO = "2026";
    self.MAP_SEDE_MX = BANDERA_MX + " MEXICO";
    self.MAP_SEDE_CA = BANDERA_CA + " CANADA";
    self.MAP_SEDE_US = BANDERA_US + " USA";
    self.MAP_SUBTITULO = "48 SELECCIONES - 16 ESTADIOS - 104 PARTIDOS";
    self.MAP_FECHA = "11 JUNIO - 19 JULIO 2026";
    self.MAP_BTN_ENTRAR = EMOJI_BALON + "  EMPEZAR AVENTURA MUNDIALISTA  " + EMOJI_BALON;
    self.MAP_BANNER_TOP = "FIFA WORLD CUP";
}

// Boton fisico Atras del dispositivo: pregunta y sale
function EntradaApp_onBack(self) {
    salirAppConConfirmacion();
}

// Boton dorado Atras de la pantalla (icono): pregunta y sale
function EntradaApp_btnAtras(self) {
    salirAppConConfirmacion();
}


// ---------------------------------------------------------
// LoginColl.xne - Login mundialista
// ---------------------------------------------------------
function LoginColl_beforeEdit(self) {
    self.MAP_TROFEO = EMOJI_TROFEO;
    self.MAP_BALON = EMOJI_BALON;
    self.MAP_BANDERA_MX = BANDERA_MX;
    self.MAP_BANDERA_US = BANDERA_US;
    self.MAP_BANDERA_CA = BANDERA_CA;
    self.MAP_TITULO_APP = "MUNDIAL 2026";
    self.MAP_SUBTITULO_APP = BANDERA_US + " USA  " + BANDERA_CA + " CANADA  " + BANDERA_MX + " MEXICO";
    self.MAP_LBL_ACCESO = "INICIO DE SESION";
    self.MAP_CREDENCIAL_INFO = "Demo: admin / ChangeMe!2026";
    self.MAP_FOOTER = EMOJI_BALON + "  FIFA WORLD CUP 2026  " + EMOJI_BALON;
    self.MAP_USUARIO = "admin";
    self.MAP_PASSWORD = "";
}

function LoginColl_aceptarLogin(self) {
    var sUsuario = self.MAP_USUARIO ? String(self.MAP_USUARIO) : "";
    var sPassword = self.MAP_PASSWORD ? String(self.MAP_PASSWORD) : "";
    if (sUsuario.length === 0 || sPassword.length === 0) {
        ui.showToast("Complete usuario y contrasena");
    } else {
        appData.login({
            userName: sUsuario,
            password: sPassword,
            entryPoint: "EntradaApp",
            onLoginSuccessful: function() {
                ui.showToast("Bienvenido al Mundial 2026!");
            },
            onLoginFailed: function() {
                ui.showToast("Usuario o contrasena incorrectos");
            }
        });
    }
}

function LoginColl_onBack(self) {
    appData.failWithMessage(-11888, "##EXITAPP##");
}


// ---------------------------------------------------------
// MenuPrincipal.xne - Menu de 4 botones
// ---------------------------------------------------------
function MenuPrincipal_beforeEdit(self) {
    self.MAP_TITULO_APP = EMOJI_TROFEO + "  MUNDIAL 2026  " + EMOJI_TROFEO;
    self.MAP_SUBTITULO_APP = "FIFA WORLD CUP - USA / CANADA / MEXICO";

    self.MAP_ICO_GRUPOS = EMOJI_TROFEO;
    self.MAP_ICO_CALENDARIO = EMOJI_CALENDARIO;
    self.MAP_ICO_EQUIPOS = EMOJI_GLOBO;
    self.MAP_ICO_ESTADIOS = EMOJI_ESTADIO;

    self.MAP_TIT_GRUPOS = "GRUPOS A - L";
    self.MAP_TIT_CALENDARIO = "CALENDARIO";
    self.MAP_TIT_EQUIPOS = "48 SELECCIONES";
    self.MAP_TIT_ESTADIOS = "16 ESTADIOS";

    self.MAP_FOOTER = EMOJI_BALON + "  11 JUN - 19 JUL 2026  " + EMOJI_BALON;
}

function MenuPrincipal_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// ListaGrupos.xne - Lista de los 12 grupos A-L
// ---------------------------------------------------------
function ListaGrupos_beforeEdit(self) {
    self.MAP_TITULO = EMOJI_TROFEO + "  FASE DE GRUPOS  " + EMOJI_TROFEO;
    self.MAP_SUBTITULO = "12 GRUPOS - 48 EQUIPOS - 72 PARTIDOS";
    self.MAP_BTN_VOLVER = "VOLVER";
}

function ListaGrupos_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// DetalleGrupo.xne - Detalle de un grupo seleccionado
// ---------------------------------------------------------
function DetalleGrupo_beforeEdit(self) {
    var letra = appData.getGlobalMacro("##GRUPO_SEL##");
    var nombre = appData.getGlobalMacro("##GRUPO_NOM##");
    self.MAP_TITULO = EMOJI_TROFEO + "  GRUPO " + letra + "  " + EMOJI_TROFEO;
    self.MAP_SUBTITULO = nombre;
    self.MAP_LBL_EQUIPOS = EMOJI_GLOBO + "  SELECCIONES  " + EMOJI_GLOBO;
    self.MAP_LBL_PARTIDOS = EMOJI_BALON + "  PARTIDOS  " + EMOJI_BALON;
    self.MAP_BTN_VOLVER = "VOLVER";
}

function DetalleGrupo_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// Calendario.xne - Lista de los 72 partidos
// ---------------------------------------------------------
function Calendario_beforeEdit(self) {
    self.MAP_TITULO = EMOJI_CALENDARIO + "  CALENDARIO  " + EMOJI_CALENDARIO;
    self.MAP_SUBTITULO = "FASE DE GRUPOS - 11 AL 27 DE JUNIO 2026";
    self.MAP_LBL_INFO = EMOJI_BALON + " 72 PARTIDOS - 16 SEDES - 3 PAISES " + EMOJI_BALON;
    self.MAP_BTN_VOLVER = "VOLVER";
}

function Calendario_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// ListaEquipos.xne - Lista de las 48 selecciones
// ---------------------------------------------------------
function ListaEquipos_beforeEdit(self) {
    self.MAP_TITULO = EMOJI_GLOBO + "  48 SELECCIONES  " + EMOJI_GLOBO;
    self.MAP_SUBTITULO = "TODAS LAS SELECCIONES PARTICIPANTES";
    self.MAP_LBL_INFO = "UEFA 16 - CAF 9 - AFC 8 - CONMEBOL 6 - CONCACAF 6 - OFC 1";
    self.MAP_BTN_VOLVER = "VOLVER";
}

function ListaEquipos_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// DetalleEquipo.xne - Detalle de seleccion + sus jugadores
// ---------------------------------------------------------
function DetalleEquipo_beforeEdit(self) {
    var nom = appData.getGlobalMacro("##EQUIPO_NOM##");
    var ban = appData.getGlobalMacro("##EQUIPO_BAN##");
    var con = appData.getGlobalMacro("##EQUIPO_CONF##");
    var grp = appData.getGlobalMacro("##EQUIPO_GRP##");
    var dsc = appData.getGlobalMacro("##EQUIPO_DESC##");
    var rnk = appData.getGlobalMacro("##EQUIPO_RNK##");

    self.MAP_BANDERA = ban;
    self.MAP_NOMBRE = nom;
    self.MAP_CONFEDERACION = EMOJI_GLOBO + " " + con;
    self.MAP_GRUPO = "GRUPO " + grp;
    self.MAP_RANKING = EMOJI_MEDALLA + " RANKING FIFA: #" + rnk;
    self.MAP_DESCRIPCION = dsc;
    self.MAP_LBL_JUGADORES = EMOJI_CAMISETA + "  JUGADORES ESTRELLA  " + EMOJI_CAMISETA;
    self.MAP_BTN_VOLVER = "VOLVER";
}

function DetalleEquipo_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// ListaEstadios.xne - Lista de las 16 sedes
// ---------------------------------------------------------
function ListaEstadios_beforeEdit(self) {
    self.MAP_TITULO = EMOJI_ESTADIO + "  16 ESTADIOS  " + EMOJI_ESTADIO;
    self.MAP_SUBTITULO = "SEDES DEL MUNDIAL 2026";
    self.MAP_LBL_INFO = BANDERA_US + " USA 11 - " + BANDERA_MX + " MX 3 - " + BANDERA_CA + " CA 2";
    self.MAP_BTN_VOLVER = "VOLVER";
}

function ListaEstadios_onBack(self) {
    ui.getView(self).exit();
}


// ---------------------------------------------------------
// Selecciones.xne - <selecteditem> al pulsar una seleccion
// ---------------------------------------------------------
function Selecciones_onSelectedItem(self) {
    appData.setGlobalMacro("##EQUIPO_COD##", self.CODIGO);
    appData.setGlobalMacro("##EQUIPO_NOM##", self.NOMBRE);
    appData.setGlobalMacro("##EQUIPO_BAN##", self.BANDERA);
    appData.setGlobalMacro("##EQUIPO_CONF##", self.CONFEDERACION);
    appData.setGlobalMacro("##EQUIPO_GRP##", self.GRUPO);
    appData.setGlobalMacro("##EQUIPO_DESC##", self.DESCRIPCION);
    appData.setGlobalMacro("##EQUIPO_RNK##", "" + self.RANKING_FIFA);
    ui.openEditView("DetalleEquipo");
}


// ---------------------------------------------------------
// Grupos.xne - <selecteditem> al pulsar un grupo
// ---------------------------------------------------------
function Grupos_onSelectedItem(self) {
    appData.setGlobalMacro("##GRUPO_SEL##", self.LETRA);
    appData.setGlobalMacro("##GRUPO_NOM##", self.NOMBRE);
    ui.openEditView("DetalleGrupo");
}


// =========================================================
// HELPER GENERICO: Boton Atras para pantallas de navegacion
// (todas las ventanas que no son EntradaApp ni Login)
// =========================================================
function btnAtrasNavegacion(self) {
    var w = ui.getView(self);
    if (w) w.exit();
}

// =========================================================
// MUNDIAL 2026 - Funciones globales
// Fichero .js puro: operadores literales (sin entidades XML)
// Motor: Rhino (ES5) - NO usar fromCodePoint, usar fromCharCode con surrogate pairs
// =========================================================

// ---------- Emojis y simbolos (surrogate pairs UTF-16) ----------
var EMOJI_TROFEO     = String.fromCharCode(0xD83C, 0xDFC6);  // U+1F3C6 trofeo
var EMOJI_BALON      = String.fromCharCode(0x26BD);          // U+26BD balon
var EMOJI_GLOBO      = String.fromCharCode(0xD83C, 0xDF0D);  // U+1F30D mundo
var EMOJI_MEDALLA    = String.fromCharCode(0xD83C, 0xDFC5);  // U+1F3C5 medalla
var EMOJI_CAMISETA   = String.fromCharCode(0xD83D, 0xDC54);  // U+1F454 corbata
var EMOJI_CALENDARIO = String.fromCharCode(0xD83D, 0xDCC5);  // U+1F4C5 calendario
var EMOJI_ESTRELLA   = String.fromCharCode(0xD83C, 0xDF1F);  // U+1F31F estrella
var EMOJI_FUEGO      = String.fromCharCode(0xD83D, 0xDD25);  // U+1F525 fuego
var EMOJI_ESTADIO    = String.fromCharCode(0xD83C, 0xDFDF);  // U+1F3DF estadio
var EMOJI_PIN        = String.fromCharCode(0xD83D, 0xDCCD);  // U+1F4CD pin

// Banderas de paises anfitriones
var BANDERA_US = String.fromCharCode(0xD83C, 0xDDFA) + String.fromCharCode(0xD83C, 0xDDF8);
var BANDERA_CA = String.fromCharCode(0xD83C, 0xDDE8) + String.fromCharCode(0xD83C, 0xDDE6);
var BANDERA_MX = String.fromCharCode(0xD83C, 0xDDF2) + String.fromCharCode(0xD83C, 0xDDFD);

// ---------- Helpers de fecha ----------
function formatearFechaCorta(fecha) {
    if (!fecha) return "";
    var meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
                 "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    var partes = fecha.split("-");
    if (partes.length < 3) return fecha;
    return partes[2] + " " + meses[parseInt(partes[1], 10) - 1];
}

function diaDeFecha(fecha) {
    if (!fecha) return "";
    var partes = fecha.split("-");
    if (partes.length < 3) return "";
    return partes[2];
}

function mesDeFecha(fecha) {
    if (!fecha) return "";
    var meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
                 "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    var partes = fecha.split("-");
    if (partes.length < 2) return "";
    return meses[parseInt(partes[1], 10) - 1];
}

// ---------- Helpers de navegacion ----------
function abrirPantalla(nombreColl) {
    ui.openEditView(nombreColl);
}

function salirPantalla() {
    ui.getView(self).exit();
}

// ---------- Dialogo de confirmacion ----------
// Devuelve true si el usuario pulsa "Si" (6), false si pulsa "No" (7)
// ui.msgBox(msg, titulo, 4) muestra dos botones Si/No
function confirmar(mensaje, titulo) {
    titulo = titulo || "Confirmar";
    var nResult = ui.msgBox(mensaje, titulo, 4);
    return nResult == 6;
}

// Salir de la aplicacion con confirmacion previa
function salirAppConConfirmacion() {
    if (confirmar("Desea salir de la aplicacion?", "Salir del Mundial 2026")) {
        appData.exit();
    }
}

// ===== exports para MPA Island mode =====
export { EntradaApp_beforeEdit, EntradaApp_onBack, EntradaApp_btnAtras, LoginColl_beforeEdit, LoginColl_aceptarLogin, LoginColl_onBack, MenuPrincipal_beforeEdit, MenuPrincipal_onBack, ListaGrupos_beforeEdit, ListaGrupos_onBack, DetalleGrupo_beforeEdit, DetalleGrupo_onBack, Calendario_beforeEdit, Calendario_onBack, ListaEquipos_beforeEdit, ListaEquipos_onBack, DetalleEquipo_beforeEdit, DetalleEquipo_onBack, ListaEstadios_beforeEdit, ListaEstadios_onBack, Selecciones_onSelectedItem, Grupos_onSelectedItem, btnAtrasNavegacion, EMOJI_TROFEO, EMOJI_BALON, EMOJI_GLOBO, EMOJI_MEDALLA, EMOJI_CAMISETA, EMOJI_CALENDARIO, EMOJI_ESTRELLA, EMOJI_FUEGO, EMOJI_ESTADIO, EMOJI_PIN, BANDERA_US, BANDERA_CA, BANDERA_MX, formatearFechaCorta, diaDeFecha, mesDeFecha, abrirPantalla, salirPantalla, confirmar, salirAppConConfirmacion };
